export default __webpack_public_path__ + "static/media/trading-icon.263f7dac.svg";